<template>
	<div>
		
		<div class="bg" style="background: linear-gradient(180deg, #FFFFFF 0%, #F0FDFD 100%);padding-bottom: 2rem;">
			<div class="container" style="margin-top: 2rem;">
				<div style="display: flex;align-items: center;">
					<div style="display: flex;flex-direction: column;width: 50rem;flex: 1;">
						<!-- <div style="position: relative;display: flex;align-items: center;font-size: 3rem;font-weight: bold;">
							<img src="../../assets/imgs/icon-dis.png" alt="" style="width: 4rem;height: 4rem;position: absolute;left: -1rem;z-index: 1;top: 0;"><span style="z-index: 10;">Global Quality Supplier</span>
						</div> -->
						<div style="" class="author-title">
							<img src="../../assets/imgs/icon-dis.png" style="" class="author-title-img"><span style="z-index: 10;">Global Quality Service Providers</span>
						</div>
						<div style="font-size: 1.5rem;font-weight: 500;margin-top: 1rem;">
							We help companies and industries thrive with change to create a more sustainable, responsible and profitable future.
						</div>
					</div>
					<div style="" class="supplier-title-r">
						GCI
					</div>
				</div>
				<div style="margin-top: 2rem;">
					<div class="loop-grid mb-30">
					    <div class="row">
							<article class="col-lg-4 col-md-6 mb-30 wow fadeInUp animated supplier-box" style="cursor: pointer;" @click="tosupplierdetail(item.id)" v-for="(item, index) in data" :key="index" 
									:data-wow-delay="index/5+'s'">
								    <div class="post-card-1 border-radius-10 hover-up">
								        <div class="post-thumb thumb-overlay img-hover-slide position-relative">
											<!-- <img :src="item.coverImage" alt="" style="" class="post-thumb thumb-overlay img-hover-slide"> -->
											<div :style="{backgroundImage: 'url('+item.coverImage+')'}"  class="post-thumb thumb-overlay img-hover-slide"
													style="background-size:cover; background-repeat: no-repeat;background-position: top center ;width: 100%;height: 13.75rem" ></div>
								        </div>
								        <div class="post-content p-30">
								            <div class="entry-meta meta-0 font-small mb-10">
												<div style="display: flex;width: 100%;overflow: hidden;flex-wrap: wrap;height: 1.3rem;">
													<div style="border: 1px solid #CBCBCB;border-radius: 2.1875rem;display: flex;align-items: center;justify-content: center;padding: 0.2rem 0.5rem;
															margin-right: 0.5rem;margin-bottom: 1rem;" v-for="(certification, cerindex) in item.certifications" :key="cerindex">
														<!-- ISO9000 -->
														{{certification.name}}
													</div>
													<!-- <div style="border: 1px solid #CBCBCB;border-radius: 2.1875rem;width: 3.75rem;height: 1.25rem;display: flex;align-items: center;justify-content: center;margin-right: 0.5rem">
														SEDEX
													</div> -->
												</div>
								            </div>
											
											<div class="d-flex post-card-content">
											    <h5 class="post-title mb-15 font-weight-900">
											        <span class="supplier-box-text">{{item.providerName}}</span>
											    </h5>
											    <div class="post-excerpt font-small text-muted">
											        <p>{{item.providerDescription}}</p>
											    </div>
											</div>
								        </div>
								    </div>
							</article>
						</div>
					</div>
					
				</div>
			</div>
					
			<div style="display: flex;align-items: center;justify-content: center;">
				<div style="display: flex;align-items: center;justify-content: center;border-radius: 2.25rem;padding: 0.5rem 1rem;margin-top: 1.5rem;
							font-size: 0.9rem;font-weight: bold;color: #181818;cursor: pointer;" class="btn-cyan-liner hover-shadow" @click="tosupplierlist()">
					All Service Providers
					<img src="../../assets/imgs/arrow-rigth.png" alt="" style="width: 1.5rem;height: 1.5rem;margin-left: 0.3rem;">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	
			import axios from 'axios'
			import {WOW} from 'wowjs'
			import {baseUrl} from '../../assets/js/public.js'
			export default {
				data() {
					return {
						// loading:false
						data:{},
					}
				},
				components: {
				},
				filters: {
		        },
				methods: {
					getData(){
						this.request({
							method: 'get',
							url: '/gci/user/provider/hot_list',
						}).then(res => {
							this.data = res.data.items
							console.info('supplier', this.data)
							this.$nextTick(()=>{
								new WOW().init();
							})
						}).catch(error => {
							console.error(error.response)
						})
					},
					tosupplierlist(){
						this.$router.push({name:'supplierlist'})
					},
					tosupplierdetail(id){
						this.$router.push({name:'supplierdetail',query:{id:id}})
					}
				},
				mounted() {
					this.getData()
					// new WOW().init();
				}
			}
	
</script>

<style scoped lang="scss">
	.bg{
		margin-top: 5rem;
		
	}
	.supplier-box-text{
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		text-overflow: ellipsis;
		overflow: hidden;
	}
	.supplier-box:hover{
		.supplier-box-text{
			color: #00E8BE;
			text-decoration: underline;
		}
	}
	.post-card-content{
		height: 7.1875rem;
	}
	.post-excerpt{
		display: -webkit-box;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;
		text-overflow: ellipsis;
		overflow: hidden;
	}
	
	.author-title{
		position: relative;display: flex;align-items: center;font-size: 3.75rem;font-weight: bold;
		
		.author-title-img{
			width: 4.0625rem;height: 4.0625rem;position: absolute;left: -30px;top:1rem;z-index: 1;
		}
	}
	.supplier-title-r{
		font-weight: 500;font-size: 10rem;color: #E4F9F7;opacity: 0.5;
	}
	.thumb-overlay::before{
		background:transparent
	}
	@media (max-width: 767px) {
		.author-title{
			font-size: 2.5rem;
			// text-align: center;
			
			.author-title-img{
				left: -1rem;
				top: 0;
			}
		}
		.supplier-title-r{
			display: none;
		}
	}
</style>